import { render, staticRenderFns } from "./RequestInfo.vue?vue&type=template&id=a2f2cdc2&scoped=true"
import script from "./RequestInfo.vue?vue&type=script&lang=js"
export * from "./RequestInfo.vue?vue&type=script&lang=js"
import style0 from "./RequestInfo.vue?vue&type=style&index=0&id=a2f2cdc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f2cdc2",
  null
  
)

export default component.exports